import { render, staticRenderFns } from "./ticket-progress.vue?vue&type=template&id=16ba1b06"
import script from "./ticket-progress.vue?vue&type=script&lang=js"
export * from "./ticket-progress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports